/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
  delivered_on: ['delivered_on:gte', 'delivered_on:lte'],
  box_type_id: 'box_type.id:in',
  vehicle_id: 'fleet_task.vehicle.id:in',
  driver_id: 'fleet_task.driver.id:in',
  customer_id: 'shipped_customer.id:in'
}

export default parseFilterDataMapping
